import { Route, Routes } from "react-router-dom";
import ActionOnApplications from "../../ContainersManager/ActionOnApplications";
import SetEvaluter from "../../Pages/Manager/SetEvaluator/index.js";
import SetScientificCommittee from "../../Pages/Manager/SetScientificCommittee/index.js";
import SetEvaluatorForm from "../../Pages/Manager/SetEvaluator/setEvaluatorForm.js";
import SetScientificCommitteeForm from "../../Pages/Manager/SetScientificCommittee/setScientificCommitteeForm.js";
import AllApplicationRequest from "../../Pages/Manager/AllApplicationRequest/index.js";
import TaskTakeAction from "../../Pages/Manager/Tasks/TaskTakeAction.js";
import ApplicationByEvaluator from "../../Pages/Manager/ApplicationByEvaluator/index.js";
import ScientificCommitteeRequsetTable from "../../Pages/Manager/SetScientificCommittee/ScientificCommitteeRequsetTable.js";
import ApplicationInfoSelectedForScientificCommittee from "../../Pages/Manager/SetScientificCommittee/ApplicationInfoSelectedForScientificCommittee.js";
import ApplicationInfoEval from "../../Pages/Manager/ApplicationByEvaluator/ApplicationBySubTask/ApplicationInfoEval.js";
import ApplicationByEvaluatorContainer from "../../ContainersManager/ApplicationByEvaluatorContainer/index.js";

import { useSelector } from "react-redux";

import ScientificCommitteeAction from "../../ContainersManager/ScientificCommitteeAction/index.js";

// import Distributor from "../../Pages/Manager/Distributor/iondex";
import React, { Suspense } from "react";
import TransferBetweenEvaluators from "../../Pages/Manager/TransferBetweenEvaluator/TransferBetweenEvaluator.js";
import FollowingApplicationEval from "../../Pages/Manager/FollowingApplicationEval/index.js";
import RecommendationsScientificCommittee from "../../Pages/Manager/RecommendationsScientificCommittee/index.js";
import ApplicationInformation from "../../Containers/ApplicationInformation/index.js";
import WorkInformationAndAcademic from "../../Containers/WorkInformationAndAcademic/index.js";
import AttachmentsAndDeclaration from "../../Containers/AttachmentsAndDeclaration/index.js";
import ScientificContributionSubmittedForTheAward from "../../Containers/ScientificContributionSubmittedForTheAward/index.js";
import RecommendationsScientificCommitteeAdmin from "../../Pages/Manager/RecommendationsScientificCommitteeAdmin/index.js";
export default function MainRoutsManager() {
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);
  const RouteManagerList = useSelector(
    (state) => state.RouteManagerReducer.RouteManager
  );
  console.log(
    JSON.parse(UserInfo?.roles)?.map((role) => role?.RoleId),
    "ssssssssdddddwwdwwdwd"
  );
  const components = {
    ActionOnApplications,
    SetEvaluter,
    SetScientificCommittee,
    SetEvaluatorForm,
    SetScientificCommitteeForm,
    AllApplicationRequest,
    TaskTakeAction,
    ApplicationByEvaluator,
    ScientificCommitteeRequsetTable,
    ApplicationInfoSelectedForScientificCommittee,
    ApplicationByEvaluatorContainer,
    ApplicationInfoEval,
    ScientificCommitteeAction,
    TransferBetweenEvaluators,
    FollowingApplicationEval,
    RecommendationsScientificCommittee,
    ApplicationInformation,
    WorkInformationAndAcademic,
    AttachmentsAndDeclaration,
    ScientificContributionSubmittedForTheAward,
    RecommendationsScientificCommitteeAdmin
  };
  console.log(RouteManagerList, "RouteManagerList");

  return (
    <Routes>
      {RouteManagerList?.map((element, index) => {
        const compKey = element?.routeManagerNameElement
          ?.replace(/"/g, "")
          ?.replace("<", "")
          ?.replace("/>", "")
          ?.trim();

        const Component = components[compKey];
        if (
          element?.roleList.some((role) =>
            JSON.parse(UserInfo?.roles)
              ?.map((role) => role?.RoleId)
              .includes(role)
          )
        ) {
          return (
            <Route
              key={index}
              path={element?.routeManagerNamePath}
              element={Component ? <Component /> : <h3>Component Not Found</h3>}
            />
          );
        }
      })}
      {/* <Route
        path="/researcher/manager/ActionOnApplications/"
        element={<ActionOnApplications />}
      />
      <Route
        path="/researcher/manager/SetEvaluter/"
        element={<SetEvaluter />}
      />
      <Route
        path="/researcher/manager/SetScientificCommittee/"
        element={<SetScientificCommittee />}
      />
      <Route
        path="/researcher/manager/SetEvaluatorForm/:userId"
        element={<SetEvaluatorForm />}
      />
      <Route
        path="/researcher/manager/SetScientificCommitteeForm/:userId"
        element={<SetScientificCommitteeForm />}
      />
      <Route
        path="/researcher/manager/AllApplicationRequest/"
        element={<AllApplicationRequest />}
      />
      <Route
        path="/researcher/manager/TakeAction/:actionId/:flowId/:roundId/:fieldId/:subjectId"
        element={<TaskTakeAction />}
      />
      <Route
        path="/researcher/manager/ApplicationByEvaluator/"
        element={<ApplicationByEvaluator />}
      />
      <Route
        path="/researcher/manager/ApplicationByEvaluator/:subTaskId"
        element={<ApplicationByEvaluatorContainer />}
      />
      <Route
        path="/researcher/manager/ScientificCommitteeRequsetTable/"
        element={<ScientificCommitteeRequsetTable />}
      />
      <Route
        path="/researcher/manager/ApplicationInfoSelectedForScientificCommittee/"
<<<<<<< HEAD
        element={<ApplicationInfoSelectedForScientificCommittee />}
      /> */}

      {/* element={<ScientificCommitteeAction />}
      /> */}
      
    </Routes>
  );
}
